import React from 'react';
import Select from 'react-select';

function SelectInput({
  label,
  labelValue,
  options,
  onChange,
  selectedOption,
  isError,
  errorMessage,
  placeholder,
  classNames,
  showErrorMessage = false,
  isSearchable = true, // ✅ new prop with default true
}) {
  return (
    <div className={classNames ? `select-input-group ${classNames}` : `select-input-group`}>
      {label ? <label>{labelValue}</label> : '' }
      <Select
        classNames={{ control: () => (isError ? 'error-outline' : '') }}
        value={options.filter(option => option.value === selectedOption)}
        onChange={onChange}
        options={options}
        placeholder={placeholder || 'Select'}
        isSearchable={isSearchable} // ✅ enable search
        styles={{
          control: (baseStyles) => ({
            ...baseStyles,
            fontSize: '14px',
          }),
          option: (baseStyles, state) => ({
            ...baseStyles,
            backgroundColor: state.isFocused ? '#a8e6d0' : 'transparent',
            color: state.isFocused ? '#000' : 'inherit',
            ':hover': {
              backgroundColor: '#a8e6d0',
            },
          }),
        }}
      />
      {showErrorMessage && (
        <p className={`error-message ${isError ? 'active' : ''}`}>
          {errorMessage || 'Error Message'}
        </p>
      )}
    </div>
  );
}

export default SelectInput;